import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=407cb682&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=407cb682&scoped=true&lang=css&"
import style1 from "./Orders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cb682",
  null
  
)

component.options.__file = "Orders.vue"
export default component.exports